import { InjectionToken } from '@angular/core';
import { ProviderName } from '../../../account/models/login-response.model';

/**
 * The payment provider the club takes card payments through.
 *
 * Clubs are on different providers, so the pages that mount a provider's card
 * form read it from here rather than naming one. Set it once in the app's
 * `provideAppConfig` call.
 */
export const PAYMENT_PROVIDER = new InjectionToken<ProviderName>('paymentProvider', {
  providedIn: 'root',
  factory: () => ProviderName.FreedomPay,
});
